import { render, staticRenderFns } from "./AirTransport_Compontent.vue?vue&type=template&id=635ae936&scoped=true&"
import script from "./AirTransport_Compontent.vue?vue&type=script&lang=js&"
export * from "./AirTransport_Compontent.vue?vue&type=script&lang=js&"
import style0 from "./AirTransport_Compontent.vue?vue&type=style&index=0&id=635ae936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ae936",
  null
  
)

export default component.exports